import Router from '../router'
import axios from 'axios'
import qs from 'qs'
import { installMockInterceptor } from '../utils/mockInterceptor'

axios.defaults.withCredentials = true;//跨域
// axios.defaults.baseURL = 'http://localhost:9000/threePieceSet/';  //测试
// axios.defaults.baseURL = 'http://120.76.42.53:9000/threePieceSet/';  //测试
axios.defaults.baseURL = 'https://okaka.bglemon.com/threePieceSet/';  //测试

// WebSocket 配置
export const wsConfig = {
    serverUrl: 'wss://okaka.bglemon.com/threePieceSet/device/wake',
    devNo: '1001'
}

axios.defaults.headers = {
    // "Content-Type": "application/x-www-form-urlencoded"
    "Content-Type": "application/x-www-form-urlencoded"
}
axios.defaults.transformRequest = function(data){
    data = qs.stringify(data);
    return data;
}

// 安装模拟数据拦截器
installMockInterceptor(axios);

axios.interceptors.request.use(
    config=>{
        const data = config;
        // let token = localStorage.getItem("blackview-token");
        // if (!!token) {
        //     config.headers.Authorization = token;
        // }
        // if (config.method === 'get') {
		// 	if (!config.params) {
		// 		data.params = {};
		// 	}
		// } else if (!config.data) {
		// 	data.data = {};
		// }
        return data;
    },
    error=>{
        return Promise.reject(error);
    }
);

export {axios}
